import React from 'react';
import {
  ChevronDown,
  ChevronRight,
  Menu,
  Search,
  SearchX,
  X,
  PawPrint,
  Play,
  Check,
  CheckCircle2,
  LogOut,
  ArrowLeft,
  ArrowRight,
  ArrowUpRight,
  History,
  FilterX,
  Trash2,
  Code,
  UserSearch,
  UserPlus,
  User,
  Users,
  CreditCard,
  Headset,
  MailPlus,
  Contact,
  Flag,
  Bell,
  Plus,
  Minus,
  PlusCircle,
  ClipboardList,
  Lock,
  BriefcaseMedical,
  Briefcase,
  Info,
  Clock,
  Calendar,
  CalendarDays,
  CalendarClock,
  CalendarRange,
  CircleEllipsis,
  FileText,
  Newspaper,
  StickyNote,
  ShieldCheck,
  Shield,
  ShieldPlus,
  BarChart3,
  SlidersHorizontal,
  Heart,
  Medal,
  TrendingUp,
  Route,
  MessagesSquare,
  FlaskConical,
  Microscope,
  Droplet,
  Dna,
  Factory,
  AlertCircle,
  AlertTriangle,
  Phone,
  Handshake,
  BadgeCheck,
  Pencil,
  MoreVertical,
  Copy,
  Archive,
  Download,
  Hourglass,
  Home,
  RefreshCw,
  Bandage,
  Mail,
  Globe,
  Palette,
  Keyboard,
  Accessibility,
  HelpCircle,
  Paperclip,
  Sparkles,
  Zap,
  Shapes,
  ListChecks,
  FilePen,
  HeartCrack,
  MapPin,
  CirclePlay,
  Settings,
  Syringe,
  Droplets,
  Eye,
  EyeOff,
  Package,
  ShoppingBag,
  ShoppingCart,
  Store,
  Snowflake,
  ReceiptText,
  Truck,
  Ban,
  KeyRound,
  ImageIcon,
  Upload,
} from 'lucide-react';

// lucide-react (v1.x) dropped brand glyphs, so LinkedIn is provided as a small
// inline SVG. It mirrors the props the Icon wrapper passes (color/size/style),
// keeping `<Icon name="linkedin" />` working alongside the Lucide icons.
const Linkedin = ({ color = 'currentColor', className, style, width = '1em', height = '1em' }) =>
  React.createElement(
    'svg',
    {
      viewBox: '0 0 24 24',
      width,
      height,
      className,
      style,
      fill: color,
      'aria-hidden': 'true',
      focusable: 'false',
    },
    React.createElement('path', {
      d: 'M20.45 20.45h-3.55v-5.57c0-1.33-.02-3.04-1.85-3.04-1.85 0-2.13 1.45-2.13 2.94v5.67H9.36V9h3.41v1.56h.05c.47-.9 1.64-1.85 3.37-1.85 3.6 0 4.27 2.37 4.27 5.46v6.28zM5.34 7.43a2.06 2.06 0 1 1 0-4.12 2.06 2.06 0 0 1 0 4.12zM7.12 20.45H3.55V9h3.57v11.45zM22.23 0H1.77C.79 0 0 .77 0 1.72v20.56C0 23.23.79 24 1.77 24h20.45c.98 0 1.78-.77 1.78-1.72V1.72C24 .77 23.21 0 22.23 0z',
    })
  );

// Maps the legacy Material Icons ligature names used across the app to their
// closest Lucide equivalent. Keys are the exact strings previously passed as
// Material Icons text content.
export const iconMap = {
  expand_more: ChevronDown,
  chevron_right: ChevronRight,
  menu: Menu,
  search: Search,
  search_off: SearchX,
  close: X,
  pets: PawPrint,
  play_arrow: Play,
  check: Check,
  check_circle: CheckCircle2,
  logout: LogOut,
  exit_to_app: LogOut,
  arrow_back: ArrowLeft,
  arrow_forward: ArrowRight,
  north_east: ArrowUpRight,
  history: History,
  filter_alt_off: FilterX,
  delete: Trash2,
  delete_forever: Trash2,
  block: Ban,
  lock_reset: KeyRound,
  code: Code,
  person: User,
  person_search: UserSearch,
  person_add: UserPlus,
  people: Users,
  groups: Users,
  users: Users,
  notifications: Bell,
  add: Plus,
  remove: Minus,
  add_circle: PlusCircle,
  assignment: ClipboardList,
  clipboard: ClipboardList,
  lock: Lock,
  medical_services: BriefcaseMedical,
  work: Briefcase,
  info: Info,
  schedule: Clock,
  calendar_today: Calendar,
  today: Calendar,
  event: CalendarDays,
  calendar_month: CalendarDays,
  event_repeat: CalendarClock,
  view_timeline: CalendarRange,
  pending: CircleEllipsis,
  description: FileText,
  article: Newspaper,
  note: StickyNote,
  security: ShieldCheck,
  verified_user: ShieldCheck,
  shield: Shield,
  health_and_safety: ShieldPlus,
  verified: BadgeCheck,
  analytics: BarChart3,
  insights: TrendingUp,
  tune: SlidersHorizontal,
  favorite: Heart,
  military_tech: Medal,
  route: Route,
  forum: MessagesSquare,
  science: FlaskConical,
  flask: FlaskConical,
  biotech: Microscope,
  bloodtype: Droplet,
  dna: Dna,
  factory: Factory,
  error_outline: AlertCircle,
  warning: AlertTriangle,
  phone: Phone,
  handshake: Handshake,
  edit: Pencil,
  more_vert: MoreVertical,
  content_copy: Copy,
  archive: Archive,
  download: Download,
  hourglass_empty: Hourglass,
  home: Home,
  update: RefreshCw,
  healing: Bandage,
  email: Mail,
  language: Globe,
  palette: Palette,
  keyboard: Keyboard,
  accessibility: Accessibility,
  help_outline: HelpCircle,
  attach_file: Paperclip,
  mail_outline: Mail,
  call: Phone,
  place: MapPin,
  water_drop: Droplets,
  auto_fix_high: Sparkles,
  bolt: Zap,
  edit_note: FilePen,
  heart_broken: HeartCrack,
  vaccines: Syringe,
  category: Shapes,
  checklist: ListChecks,
  play_circle: CirclePlay,
  settings: Settings,
  error: AlertCircle,
  visibility: Eye,
  visibility_off: EyeOff,
  inventory_2: Package,
  shopping_bag: ShoppingBag,
  shopping_cart: ShoppingCart,
  storefront: Store,
  ac_unit: Snowflake,
  receipt_long: ReceiptText,
  local_shipping: Truck,
  manage_accounts: Users,
  group: Users,
  inbox: Archive,
  payments: CreditCard,
  support_agent: Headset,
  mark_email_unread: MailPlus,
  trending_up: TrendingUp,
  contact_mail: Contact,
  flag: Flag,
  mark_email_read: Mail,
  link_off: AlertCircle,
  linkedin: Linkedin,
  image: ImageIcon,
  upload: Upload,
};

export default iconMap;
